import axios from '@/plugins/axios.js';
const resource = 'relatorio/relquestionario';

export default {
    recuperarRelatorioQuestinarioFiltrado(payload) {
        return axios.post(`${resource}/recuperarRelQuestionarioFiltrado`, payload);
    }
};